import Skeleton from "react-loading-skeleton";

import { TimelineRecordElement } from "./TimelineRecordElement";

export function AcuityHistoryTimelineSkeleton() {
  return (
    <ul className="tw:relative tw:ml-1.5 tw:flex tw:flex-col tw:gap-y-5 tw:border-s tw:border-l tw:border-fill-quaternary tw:pr-3 tw:text-sm tw:text-text-primary">
      {Array.from({ length: 3 }).map((_, i) => (
        <TimelineRecordSkeleton key={i} />
      ))}
    </ul>
  );
}

function TimelineRecordSkeleton() {
  return (
    <TimelineRecordElement>
      <div className="tw:flex tw:min-w-40 tw:flex-col tw:gap-y-1 tw:border-r tw:border-fill-quaternary tw:pr-4">
        <Skeleton height={16} width={120} />
        <Skeleton borderRadius={4} height={20} width={60} />
      </div>
      <dl className="tw:grid tw:w-full tw:grid-cols-[minmax(160px,1fr)_1fr] tw:gap-y-2">
        <Skeleton height={16} width={50} />
        <Skeleton height={20} width={80} />

        <Skeleton height={16} width={90} />
        <Skeleton height={16} width={130} />

        <Skeleton height={16} width={70} />
        <Skeleton height={16} width="80%" />

        <Skeleton height={16} width={110} />
        <Skeleton height={16} width="60%" />
      </dl>
    </TimelineRecordElement>
  );
}
